import { useSearchParams } from 'react-router-dom'

import {
  SUPPORT_CHAT_KEY,
  SUPPORT_CHAT_VALUE,
} from '~/features/chatbot/constants'

const useIsSupportChat = () => {
  const [searchParams] = useSearchParams()

  const isSupportChat =
    searchParams.get(SUPPORT_CHAT_KEY) === SUPPORT_CHAT_VALUE

  return {
    isSupportChat,
  }
}

export default useIsSupportChat
